// Returns the best WhatsApp URL for the current device.
// Mobile: wa.me (deep-links into the installed WhatsApp app).
// Desktop: web.whatsapp.com/send (skips the api.whatsapp.com redirect that some networks block).
export const buildWhatsAppUrl = (number, message = "") => {
  const cleanNum = String(number).replace(/[^\d]/g, "");
  const encoded = message ? encodeURIComponent(message) : "";

  let isMobile = false;
  if (typeof navigator !== "undefined") {
    const ua = navigator.userAgent || "";
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi|Mobile|Silk|Kindle|Tablet/i.test(ua)) {
      isMobile = true;
    } else if (
      typeof window !== "undefined" &&
      ("ontouchstart" in window || (navigator.maxTouchPoints || 0) > 0) &&
      window.innerWidth < 900
    ) {
      isMobile = true;
    }
  }

  if (isMobile) {
    // Direct app scheme — opens WhatsApp / WhatsApp Business on the device immediately.
    // Avoids wa.me's fallback to web.whatsapp.com when the universal-link handler isn't fired.
    return `whatsapp://send?phone=${cleanNum}${encoded ? `&text=${encoded}` : ""}`;
  }
  return `https://web.whatsapp.com/send?phone=${cleanNum}${encoded ? `&text=${encoded}` : ""}`;
};

export const buildTelUrl = (number) => `tel:+${String(number).replace(/[^\d]/g, "")}`;
